import { Card } from '@/shared/ui/card';

interface SectionCardProps {
  title: string;
  subtitle: string;
  icon: React.ComponentType<{ className?: string }>;
  iconBg: string;
  iconColor: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

/**
 * A non-collapsible section card sharing the header layout of CollapsibleCard
 * but with its content always visible and no collapse toggle. Used for sections
 * that should never be hidden (e.g. role assignments).
 */
export function SectionCard({
  title,
  subtitle,
  icon: Icon,
  iconBg,
  iconColor,
  children,
  actions,
}: SectionCardProps) {
  return (
    <Card className="bg-card border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg ${iconBg} flex items-center justify-center`}>
            <Icon className={`w-5 h-5 ${iconColor}`} />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-foreground">{title}</h3>
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          </div>
          {actions}
        </div>
      </div>
      <div className="p-6">{children}</div>
    </Card>
  );
}
